import React, { useState, useEffect, useRef } from "react";
import { Table, Select, Tooltip, Space, Button, Input, Drawer, Spin } from "antd";
import Highlighter from "react-highlight-words";
import { cloneDeep, get, isEmpty, head, forEach } from "lodash";
import { SearchOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";

import LayoutOfDashboard from "@layout/defaultForDashboard";
// import { useConfigStore } from "@stores/useConfigStore";
import { useHighIntensityProgramStore } from "@stores/highIntensityStore";
import HighIntensityCareMgmtService from "@services/highIntensityCareMgmt.service";
import CareCoordinationService from "@services/care-coordination";
import useSession from "@utils/useSession";
import { formatDisplayDate, formatDownloadFileNameDate } from "@utils/helpers";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
// import TablePreloader from "@components/"
import HipDrawer from "@pages/CM-Lite/HIPDrawer/HipDrawer";
import { ACTIVE, COMPLETE, INPROGRESS } from "../../member-details/care-coordination/constants";
import TablePreloader from "@components/preloaders/Table/tablePreLoader";
import "./Hip-Dahboard.scss";
import { TableLocale } from "@components/noDataFound";

const { Option } = Select;

const HipDashboard = () => {
  const isHIPOpenDrawer = useHighIntensityProgramStore((state) => state.isHIPOpenDrawer);
  const setIsHIPOpenDrawer = useHighIntensityProgramStore((state) => state.setIsHIPOpenDrawer);
  const hipMemberList = useHighIntensityProgramStore((state) => state.hipMemberList);
  const setHipMemberList = useHighIntensityProgramStore((state) => state.setHipMemberList);
  const setSelectedHipMember = useHighIntensityProgramStore((state) => state.setSelectedHipMember);
  const hipDashBoardPageSize = useHighIntensityProgramStore((state) => state.hipDashBoardPageSize);
  const setHipDashBoardPageSize = useHighIntensityProgramStore((state) => state.setHipDashBoardPageSize);
  const hipDashBoardCurrentPage = useHighIntensityProgramStore((state) => state.hipDashBoardCurrentPage);
  const setHipDashBoardCurrentPage = useHighIntensityProgramStore((state) => state.setHipDashBoardCurrentPage);
  const loggedInUserCategory = useHighIntensityProgramStore((state) => state.loggedInUserCategory);
  const setLoggedInUserCategory = useHighIntensityProgramStore((state) => state.setLoggedInUserCategory);
  const hipFilters = useHighIntensityProgramStore((state) => state.hipFilters);
  const setHipFilters = useHighIntensityProgramStore((state) => state.setHipFilters);

  const session = useSession();
  const [taskStatusFilter, setTaskStatusFilter] = useState<any>(undefined);
  const [selectedRegistryDropDown, setSelectedRegistryDropDown] = useState<any>(undefined);
  const [registryDropDownOption, setRegistryDropDownOption] = useState([]);
  const [column, setColumn] = useState<any>([]);
  // const [rowsPerPage, setPageSize] = useState<any>(5);
  // const [rowsPerPageToggle, setRowsPerPageToggle] = useState<boolean>(false);
  // const [currentPage, setCurrentPage] = useState<any>(1);
  const [searchText, setSearchText] = useState("");
  // const [searchedColumn, setSearchedColumn] = useState("");
  const [loader, setLoader] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  // const [memberList, setMemberList] = useState<any>([]);

  // const dropDownOption = ["All Patients (24)"];
  const selectAbleFilter = [
    { label: "To do", value: ACTIVE },
    { label: "In Progress", value: INPROGRESS },
    { label: "Done", value: COMPLETE },
    { label: "All My Patients", value: undefined },
  ];
  const rowsPerPageArray: any[] = ["5", "10", "15", "20", "25", "30", "35", "40", "45", "50"];
  const actionColumn = {
    column_id: 999999,
    key: "action",
    tableHeaderName: "ACTION",
    displayName: "ACTION",
    order: 999999,
    isDraggable: false,
    isSelected: true,
    dataIndex: "action",
    isDisplay: "Y",
    isDefault: "N",
    subColumns: [],
    defaultDisplayOrder: 9999999,
    type: null,
    title: "ACTION",
    label: "ACTION",
    sequence: 99999,
    width: 200,
    ellipsis: {
      showTitle: false,
    },
    colorCoded: false,
  };

  useEffect(() => {
    console.log("HipDashboard | UseEffect-1");
    setLoader(true);
    getColumnConfig();
    getRegistryDropDown();
    getHipMembers();
    getAssigneeCategory();
  }, []);

  useEffect(() => {
    console.log("HipDashboard | UseEffect-2");
    appInsights.trackPageView({ name: "CM Lite - DashBoard" });
  }, []);

  const getMembersOnFilterChange = async (taskStatus: any, dropDownOption: any) => {
    console.log("HipDashboard | getMembersOnFilterChange");
    setDataLoader(true);
    await getRegistryDropDown();
    await getHipMembers(taskStatus, dropDownOption === "All Patient" ? undefined : dropDownOption);
  };

  const getColumnConfig = () => {
    console.log("HipDashboard | getColumnConfig");
    HighIntensityCareMgmtService.getColumnsList().subscribe({
      next: async (v: any) => {
        const tcf = cloneDeep(v.data.data.columns)
          ?.map((item: any) => {
            let newItem = {
              ...item,
              title: item.tableHeaderName,
              label: item.displayName,
              sequence: item.order,
              width: 200,
              // sortOrder: sortedInfo?.columnKey === item.dataIndex ? sortedInfo.order : undefined,
              ellipsis: {
                showTitle: false,
              },
              colorCoded: false,
              sorter: (a: any, b: any) => {
                if (Number(a[item.dataIndex]) && Number(b[item.dataIndex])) {
                  return Number(a[item.dataIndex]) && Number(b[item.dataIndex]) ? Number([item.dataIndex]) - Number(b[item.dataIndex]) : 0;
                }
                return a[item.dataIndex] && b[item.dataIndex] ? a[item.dataIndex].localeCompare(b[item.dataIndex]) : 0;
              },
              // sort: (a: any, b: any) => a.order - b.order,
              sortOrder: item.dataIndex === "assignment_date" ? "descend" : null,
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }: any) => (
                <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                  <Input
                    ref={searchInput}
                    placeholder={`Search ${item.displayName}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, item.dataIndex)}
                    style={{ marginBottom: 8, display: "block" }}
                  />
                  <Space>
                    <Button type="primary" onClick={() => handleSearch(selectedKeys as string[], confirm, item.dataIndex)} icon={<SearchOutlined />} size="small" style={{ width: 90 }}>
                      Search
                    </Button>
                    <Button
                      onClick={() => {
                        setSelectedKeys([]);
                        clearFilters && handleReset(clearFilters);
                        handleSearch([], confirm, item.dataIndex);
                      }}
                      size="small"
                      style={{ width: 90 }}
                    >
                      Reset
                    </Button>
                  </Space>
                </div>
              ),
              filterIcon: (filtered: boolean) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
              onFilter: (value: any, record: any) => {
                if (item.dataIndex === "assignment_date") {
                  const searchString = moment(record[item.dataIndex]).isValid() ? formatDisplayDate(record[item.dataIndex], "createDateFormat") : "--";
                  return searchString.toLowerCase().includes((value as string).toLowerCase());
                } else {
                  return record[item.dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes((value as string).toLowerCase());
                }
              },
              onFilterDropdownOpenChange: (visible: any) => {
                if (visible) {
                  setTimeout(() => searchInput.current?.select(), 100);
                }
              },
              // render: (text: any, record: any) => highlighterDiv(text, record, item),
            };
            return newItem;
          })
          .filter((item: any) => item.isDisplay === "Y");
        tcf.push(actionColumn);
        setColumn(tcf);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const getHipMembers = (taskStatus?: any, dropDownOPtion?: any) => {
    console.log("HipDashboard | getHipMembers");
    HighIntensityCareMgmtService.getHipMembers(taskStatus, dropDownOPtion).subscribe({
      next: async (v: any) => {
        // setMemberList(v.data.data);
        setHipMemberList(v.data.data);
        setLoader(false);
        setDataLoader(false);
      },
      error: (e) => {
        console.log(e);
        setLoader(false);
        setDataLoader(false);
      },
    });
  };

  const getRegistryDropDown = () => {
    console.log("HipDashboard | getRegistryDropDown");
    HighIntensityCareMgmtService.getRegistryDropDown().subscribe({
      next: async (v: any) => {
        setRegistryDropDownOption(v.data.data);
        if (!selectedRegistryDropDown) {
          setSelectedRegistryDropDown(get(head(v.data.data), "label", undefined));
        }
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const getAssigneeCategory = () => {
    console.log("HipDashboard | getAssigneeCategory");
    CareCoordinationService.fetchAssigneeList().subscribe({
      next: (v) => {
        const response = v?.data?.data;
        let assignee: any = undefined;
        const localStorageUser: any = localStorage.getItem("_user") !== null ? localStorage.getItem("_user") : "{}";
        const parsedLocalStorageUser = JSON.parse(localStorageUser).id;
        forEach(response, (item: any) => {
          forEach(item?.children, (assigneeObj: any) => {
            if (assigneeObj?.assigneeValue?.toString() === parsedLocalStorageUser?.toString()) {
              assignee = item;
            }
          });
        });
        setLoggedInUserCategory(assignee);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const searchInput = useRef<any>(null);
  const handleSearch = (selectedKeys: string[], confirm: (param?: any) => void, dataIndex: any) => {
    confirm();
    setSearchText(selectedKeys.length > 0 ? selectedKeys[0] : "");
    setHipFilters({
      ...hipFilters,
      searchText: selectedKeys.length > 0 ? selectedKeys[0] : "",
      searchDataIndex: selectedKeys.length > 0 ? dataIndex : "",
    });
  };

  const handleReset = (clearFilters: () => void) => {
    setSearchText("");
    setHipFilters({
      ...hipFilters,
      searchText: "",
      searchDataIndex: "",
    });
    clearFilters();
  };

  // function(pagination, filters, sorter, extra: { currentDataSource: [], action: paginate | sort | filter })
  const handleTableChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    const tempColumn = cloneDeep(column).map((item: any) => {
      let tempItem = cloneDeep(item);
      if (item.dataIndex === "action") {
        return tempItem;
      }
      tempItem = {
        ...tempItem,
        sortOrder:
          sorter.column === undefined && sorter.order === undefined
            ? item.dataIndex === "assignment_date"
              ? sorter.columnKey === "assignment_date"
                ? "ascend"
                : "descend"
              : null
            : sorter.columnKey === item.dataIndex
            ? sorter.order
            : null,
        sorter: (a: any, b: any) => {
          if (Number(a[item.dataIndex]) && Number(b[item.dataIndex])) {
            return Number(a[item.dataIndex]) && Number(b[item.dataIndex]) ? Number(a[item.dataIndex]) - Number(b[item.dataIndex]) : 0;
          }
          return a[item.dataIndex] && b[item.dataIndex] ? a[item.dataIndex].localeCompare(b[item.dataIndex]) : 0;
        },
      };
      return tempItem;
    });
    setColumn(tempColumn);
    const sortOrder = sorter.column === undefined && sorter.order === undefined ? (sorter.columnKey === "assignment_date" ? "ascend" : "descend") : sorter.order;
    const sortColumn = sorter.column === undefined && sorter.order === undefined && sorter.columnKey !== "assignment_date" ? "assignment_date" : sorter.columnKey;
    setHipFilters({
      ...hipFilters,
      sortDataIndex: sortColumn,
      sortOrder: sortOrder,
    });
  };

  const colConfig: any = column.map((item: any) => {
    if (item.dataIndex === "action") {
      return { ...item, render: (text: any, record: any) => highlighterDiv(text, record, item) };
    }
    return {
      ...item,
      render: (text: any, record: any) => highlighterDiv(text, record, item),
    };
  });

  const highlighterDiv = (text: any, record: any, item: any) => {
    switch (item.dataIndex) {
      // case "patient_name":
      //   return (
      //     <Highlighter
      //       highlightStyle={{ backgroundColor: "#ffc069", padding: 0, fontSize: "500", color: "#0072E3" }}
      //       searchWords={[searchText]}
      //       autoEscape
      //       className={"member-name"}
      //       textToHighlight={!isEmpty(text?.toString()) ? text?.toString() : "--"}
      //     />
      //   );
      case "action":
        return (
          <div className="hipDashBoard__table-highLighted action-button">
            <Button
              type="primary"
              onClick={() => {
                onCloseHIPDrawer();
                setSelectedHipMember(record);
              }}
            >
              Open
            </Button>
          </div>
        );
      case "assignment_date":
        return (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={moment(text).isValid() ? formatDisplayDate(text, "createDateFormat") : "--"}
          />
        );
      case "intst_reason_txt":
        return (
          <div className="hipDashBoard__table-highLighted">
            {text.split(",").length > 2 ? text.split(",").slice(0, 2).join(", ") : text}
            {text.split(",").length > 2 ? (
              <Tooltip title={toolTipContainer(text.split(",").slice(2, text.split(",").length))}>
                <span className="hipDashBoard__table-highLighted bold-more-items">{`, +${text.split(",").length - 2} More`}</span>
              </Tooltip>
            ) : null}
          </div>
        );
      default:
        return <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={!isEmpty(text?.toString()) ? text?.toString() : "--"} />;
    }
  };

  const toolTipContainer = (arr: any) => {
    return (
      <div>
        {arr.map((item: any) => {
          return <div>{item}</div>;
        })}
      </div>
    );
  };
  const onCloseHIPDrawer = () => {
    setIsHIPOpenDrawer(!isHIPOpenDrawer);
  };

  const downloadMembers = () => {
    console.log("HipDashboard | downloadMembers");

    let filteredMemberList = hipMemberList
      ?.filter((item: any) => (hipFilters?.searchText?.trim() !== "" ? item[hipFilters.searchDataIndex]?.toLowerCase()?.includes(hipFilters?.searchText?.toLowerCase()) : true))
      .sort((a: any, b: any) => {
        if (Number(a[hipFilters.sortDataIndex]) && Number(b[hipFilters.sortDataIndex])) {
          if (hipFilters.sortOrder === "ascend") {
            return Number(a[hipFilters.sortDataIndex]) && Number(b[hipFilters.sortDataIndex]) ? Number(a[hipFilters.sortDataIndex]) - Number(b[hipFilters.sortDataIndex]) : 0;
          }
          return Number(a[hipFilters.sortDataIndex]) && Number(b[hipFilters.sortDataIndex]) ? Number(b[hipFilters.sortDataIndex]) - Number(a[hipFilters.sortDataIndex]) : 0;
        }
        if (hipFilters.sortOrder === "ascend") {
          return a[hipFilters.sortDataIndex] && b[hipFilters.sortDataIndex] ? a[hipFilters.sortDataIndex].localeCompare(b[hipFilters.sortDataIndex]) : 0;
        }
        return a[hipFilters.sortDataIndex] && b[hipFilters.sortDataIndex] ? b[hipFilters.sortDataIndex].localeCompare(a[hipFilters.sortDataIndex]) : 0;
      });

    const excelData = filteredMemberList.map((row: any) => {
      let obj: any = {};
      forEach(column, (col: any) => {
        if (col.dataIndex !== "action" && col.isDisplay === "Y") {
          if (col.dataIndex === "assignment_date") {
            obj[col.tableHeaderName] = moment(row[col.dataIndex]).isValid() ? formatDisplayDate(row[col.dataIndex], "createDateFormat") : "--";
          } else {
            obj[col.tableHeaderName] = row[col.dataIndex];
          }
        }
      });
      return obj;
    });
    const fileName = `High_Intensity_Patients_Detail_${formatDownloadFileNameDate(new Date())}.csv`;
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "High_Intensity_Patients_Detail");
    XLSX.writeFile(wb, fileName);
  };

  // const getFilteredMembersList = () => {
  //   setMemberList(cloneDeep(memberList).slice((hipDashBoardCurrentPage-1) * hipDashBoardPageSize,  hipDashBoardPageSize))
  // }
  return (
    <LayoutOfDashboard>
      <div className="hip-dashboard">
        <div className="hip-dashboard__header">
          <div className="hip-dashboard__header__salutation">
            <div className="hip-dashboard__header__salutation__user">{`Welcome, ${session?.user?.firstName}!`}</div>
            {loggedInUserCategory?.categoryLabel ? <div className="hip-dashboard__header__salutation__user-type">{loggedInUserCategory?.categoryLabel}</div> : null}
          </div>
        </div>
        <div className="hip-dashboard__body">
          {loader ? (
            <TablePreloader rows={hipDashBoardPageSize} />
          ) : (
            <>
              <div className="hip-dashboard__body__table-handler">
                <div className="hip-dashboard__body__table-handler__section-1">
                  <div className="hip-dashboard__body__table-handler__section-1__dropDown">
                    <Select
                      // style={{ width: 248 }}
                      value={selectedRegistryDropDown ? selectedRegistryDropDown : get(head(registryDropDownOption), "label", undefined)}
                      onChange={async (e) => {
                        await setSelectedRegistryDropDown(e);
                        getMembersOnFilterChange(taskStatusFilter, e);
                      }}
                    >
                      {registryDropDownOption.map((item: any, index: any) => (
                        <Option key={index} value={item.label}>
                          <span>{`${item.label} (${item.count})`}</span>
                        </Option>
                      ))}
                    </Select>
                  </div>
                  <div className="hip-dashboard__body__table-handler__section-1__taskStatus">
                    {selectAbleFilter.map((item: any, index: any) => (
                      <div
                        className={`hip-dashboard__body__table-handler__section-1__taskStatus__item ${taskStatusFilter === item.value ? "active-task-status" : ""}`}
                        key={index}
                        style={{ borderRadius: `${index === 0 ? "4px 0px 0px 4px" : index === selectAbleFilter.length - 1 ? "0px 4px 4px 0px" : "0px 0px 0px 0px"}` }}
                        onClick={async () => {
                          if (taskStatusFilter !== item.value) {
                            await setTaskStatusFilter(item.value);
                            getMembersOnFilterChange(item.value, selectedRegistryDropDown);
                          }
                        }}
                      >
                        <div>{item.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="hip-dashboard__body__table-handler__section-2">
                  {hipMemberList.length > 0 ? (
                    <div className={`hip-dashboard__body__table-handler__section-2__download`}>
                      <Tooltip title="Download XLS" overlayClassName="download-tooltip">
                        <i className="btn-icon icon-download clr-n125" style={{ width: "20px", height: "42px" }} onClick={() => downloadMembers()} />
                      </Tooltip>
                    </div>
                  ) : null}
                </div>
              </div>
              <Spin spinning={dataLoader} indicator={<HealthemSpinner size={60} />}>
                <div className="hip-dashboard__body__table">
                  <Table
                    id="member-table"
                    bordered={true}
                    tableLayout="fixed"
                    columns={colConfig}
                    scroll={{ y: window.innerHeight - 400, x: true }}
                    dataSource={hipMemberList}
                    locale={TableLocale}
                    onChange={handleTableChange}
                    pagination={{
                      pageSizeOptions: rowsPerPageArray,
                      defaultPageSize: hipDashBoardPageSize,
                      responsive: true,
                      // total: hipMemberList.length,
                      showSizeChanger: true,
                      onChange: (page, pageSize) => {
                        if (hipDashBoardCurrentPage !== page) {
                          setHipDashBoardCurrentPage(page);
                        }
                      },
                      // showTotal: (total: any, range: any) => (
                      //   <>
                      //     <span style={{ color: "#091e42" }}>
                      //       {hipDashBoardPageSize * hipDashBoardCurrentPage - (hipDashBoardPageSize - 1)} -{" "}
                      //       {hipDashBoardPageSize * hipDashBoardCurrentPage > total
                      //         ? total + hipDashBoardPageSize * hipDashBoardCurrentPage - (hipDashBoardPageSize - 1) - 1
                      //         : hipDashBoardPageSize * hipDashBoardCurrentPage + hipDashBoardPageSize * hipDashBoardCurrentPage - (hipDashBoardPageSize - 1) - 1}
                      //     </span>
                      //     <span> of {total}</span>
                      //   </>
                      // ),
                      showTotal: (total: any, range: any) => `${range[0]}-${range[1]} of ${total} `,
                      onShowSizeChange: (current, size) => setHipDashBoardPageSize(size),
                    }}
                  />
                </div>
              </Spin>
              {/* {true ? (
                <div className="hip-dashboard__body__table-pagination">
                  <div>
                    Show
                    <Select
                      defaultValue={hipDashBoardPageSize}
                      style={{ width: 64, margin: "8px 8px" }}
                      onClick={() => setRowsPerPageToggle(!rowsPerPageToggle)}
                      onChange={(e) => { console.log(e); setHipDashBoardPageSize(e); getFilteredMembersList()}}
                      open={rowsPerPageToggle}
                      suffixIcon={<CaretDownOutlined />}
                    >
                      {rowsPerPageArray.map((val) => (
                        <Option key={val} value={val}>
                          {val}
                        </Option>
                      ))}
                    </Select>
                    rows per page
                  </div>
                  {hipMemberList?.length > 0 && (
                    <Pagination
                      total={hipMemberList.length}
                      showTotal={(total: any, range: any) => (
                        <>
                          <span style={{ color: "#091e42" }}>
                            {hipDashBoardPageSize * hipDashBoardCurrentPage - (hipDashBoardPageSize - 1)} -{" "}
                            {hipDashBoardPageSize * hipDashBoardCurrentPage > total
                              ? total + hipDashBoardPageSize * hipDashBoardCurrentPage - (hipDashBoardPageSize - 1) - 1
                              : hipDashBoardPageSize * hipDashBoardCurrentPage + hipDashBoardPageSize * hipDashBoardCurrentPage - (hipDashBoardPageSize - 1) - 1}
                          </span>
                          <span> of {total}</span>
                        </>
                      )}
                      key={hipDashBoardPageSize}
                      defaultPageSize={hipDashBoardPageSize}
                      defaultCurrent={hipDashBoardCurrentPage}
                      current={hipDashBoardCurrentPage}
                      showSizeChanger={false}
                      onChange={(e: any) => {
                        setHipDashBoardCurrentPage(e);
                      }}
                    />
                  )}
                </div>
              ) : null} */}
            </>
          )}
        </div>
        <Drawer
          destroyOnClose={true}
          placement="right"
          closable={false}
          onClose={onCloseHIPDrawer}
          visible={isHIPOpenDrawer}
          key="right"
          width={0.8 * window.innerWidth}
          className={`membersListingDrawer hip-drawer custom-scroll-bar`}
        >
          <HipDrawer />
        </Drawer>
      </div>
    </LayoutOfDashboard>
  );
};

export default withAITracking(reactPlugin, HipDashboard);
